import React, { Fragment, FunctionComponent } from "react";
import FormFieldContent from "./FormFieldsContent.model";
import InputField from "../InputField/InputField";
import TextareaField from "../TextareaField/TextareaField";
import RadioButtons from "../RadioButtons/RadioButtons";
import Checkbox from "../Checkbox/Checkbox";
import Dropdown from "../Dropdown/Dropdown";

const Field: FunctionComponent<FormFieldContent> = (props) => {

    const renderControl = (props: FormFieldContent): null | JSX.Element => {
        switch (props.fieldTypeId) {
            case "3f92e01b-29e2-4a30-bf33-9df5580ed52c": {
                return (<InputField {...props} />);
            }
            case "0dd29d42-a6a5-11de-a2f2-222256d89593": {
                return (<Dropdown {...props} />);
            }
            case "023f09ac-1445-4bcb-b8fa-ab49f33bd046": {
                return (<TextareaField {...props} />);
            }
            case "903df9b0-a78c-11de-9fc1-db7a56d89593": {
                return (<RadioButtons {...props} />);
            }
            case "d5c0c390-ae9a-11de-a69e-666455d89593": {
                return (<Checkbox {...props} />);
            }
            case "a72c9df9-3847-47cf-afb8-b86773fd12cd": {
                return (<Checkbox {...props} />);
            }
            default: {
                return null;
            }
        }
    };

    return (
        <Fragment>
            {renderControl(props)}
        </Fragment>
    );
};

export default Field;
